import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ChargeDetailContMain from "presentation/view/container/ChargeDetailMaintenance/ChargeDetailContMain";

CommonEntrypoint(<ChargeDetailContMain/>)